import Mustache from "mustache";
import JsFileDownloader from "js-file-downloader";

export const getRepliesContext = entries => {
  return entries.reduce((p, c, i) => {
    return {
      ...p,
      ...Object.entries(c).reduce(
        (test, [key, data]) => ({
          ...test,
          [`TS${i + 1}_${key}`]: data,
        }),
        {}
      ),
    };
  }, {});
};

export const insertVariablesIntoHtml = (finalHtml = "", entries) => {
  return Mustache.render(finalHtml, {
    REPORT_URL: window.location.href,
    ...getRepliesContext(entries),
  });
};

export const handlePdfFileDownload = async (sessionId, filename) => {
  return new JsFileDownloader({
    url: `${import.meta.env.VITE_API_URL}/cube-cockpit/${sessionId}/export`,
    filename,
    timeout: 120000,
  });
};
